const J  = { fontFamily: "'Josefin Sans', sans-serif" };
const CG = { fontFamily: "'Libre Baskerville', Georgia, serif" };

export default function HelpSheet({ title, items, onClose }) {
  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9300,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex', alignItems: 'flex-end',
        animation: 'fadeIn 0.18s ease',
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '100%', maxWidth: 480, margin: '0 auto',
          background: 'var(--bg)',
          borderRadius: '18px 18px 0 0',
          padding: '1.25rem 1.5rem 2.5rem',
          animation: 'slideUp 0.25s ease',
          boxShadow: '0 -6px 40px rgba(0,0,0,0.35)',
          maxHeight: '85svh', overflowY: 'auto',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Handle */}
        <div style={{ width: 36, height: 4, borderRadius: 2, background: 'var(--border)', margin: '0 auto 1.1rem' }} />

        {/* Title */}
        <div style={{ ...J, fontSize: '0.52rem', letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '1.1rem' }}>
          {title}
        </div>

        {/* Items */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem', marginBottom: '1.5rem' }}>
          {items.map(({ icon, label, desc }) => (
            <div key={label} style={{ display: 'flex', gap: '0.85rem', alignItems: 'flex-start' }}>
              <span style={{ fontSize: '1.1rem', flexShrink: 0, marginTop: 1 }}>{icon}</span>
              <div>
                <div style={{ ...J, fontSize: '0.6rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--text)', fontWeight: 600, marginBottom: '0.25rem' }}>
                  {label}
                </div>
                <div style={{ ...CG, fontSize: '0.83rem', color: 'var(--text2)', lineHeight: 1.65 }}>
                  {desc}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Close */}
        <button
          onClick={onClose}
          style={{
            ...J, width: '100%', padding: '0.75rem',
            background: 'var(--bg2)', border: '1px solid var(--border)',
            borderRadius: 8, fontSize: '0.58rem', letterSpacing: '0.14em',
            textTransform: 'uppercase', color: 'var(--text3)', cursor: 'pointer',
          }}
        >
          Got it
        </button>
      </div>
    </div>
  );
}
